/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {findChargebackReport} from '../api'

export const useMutationFindChargebackReport = createReactQueryMutationHook('findChargebackReport', findChargebackReport)
